<template>
  <div class="form-group">
    <input
      v-if="isChangeable"
      type="file"
      :accept="acceptedFileTypes"
      class="mb6 file-input"
      ref="refUploadFile"
      @change="handleFileUpload"
      :disabled="previewFiles.length >= MAX_SAVABLE_FILES_COUNT"
    />
    <div class="file-preview-area mt6">
      <div v-for="file in previewFiles" :key="file.id" class="file-box">
        <template v-if="isImageFileType(file.path)">
          <img :src="file.content" class="image" />
          <i v-if="isChangeable" class="fa fa-times-circle remove-image-btn" @click="removeFile(file.id)" />
        </template>
        <template v-else>
          <i class="far fa-3x" :class="fileTypeIconFromFilePath(file.path)" />
          <i v-if="isChangeable" class="fa fa-times-circle remove-file-btn" @click="removeFile(file.id)" />
          <div class="file-name">
            {{ file.name }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  watch,
} from 'vue';
import type { CandidateFile } from 'src/models';
import {
  isImageFileType,
  fileTypeIconFromFilePath,
} from 'src/lib/fileHelper';
import { MAX_SAVABLE_FILES_COUNT } from 'src/lib/commentHelper';

interface Props {
  previewFiles: CandidateFile[];
  isChangeable: boolean;
  acceptedFileTypes: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'file-upload', payload: FileList): void;
  (e: 'remove-file', payload: number): void;
}>();

const refUploadFile = ref<HTMLInputElement>();
const handleFileUpload = () => {
  const fileList = refUploadFile.value?.files;
  if (!fileList) return;

  emit('file-upload', fileList);
};
const removeFile = (fileId: number) => {
  emit('remove-file', fileId);
};
watch(() => props.previewFiles, () => {
  if (refUploadFile.value && props.previewFiles.length === 0) {
    refUploadFile.value.value = '';
  }
});
</script>

<style lang="scss"  scoped>
.file-input {
  font-size: 14px;
}
.file-preview-area {
  display: flex;
  width: 100%;
  .file-box {
    cursor: default;
    position: relative;
    margin-left: 6px;
    margin-right: 14px;
    .remove-image-btn, .remove-file-btn {
      position: absolute;
      top: -0.4em;
      cursor: pointer;
      background-color: #ffffff;
      border-radius: 8px;
    }
    .remove-image-btn {
      right: -0.4em;
    }
    .remove-file-btn {
      left: 1.6em;
    }
    .image {
      max-height: 72px;
      max-width: 128px;
      border: 1px solid #dddddd;
    }
    .fa-file-excel {
      color: #007234;
    }
    .fa-file-word {
      color: #2A5396;
    }
    .fa-file-powerpoint {
      color: #DE5B26;
    }
    .fa-file {
      color: black;
    }
    .file-name {
      font-size: 0.8em;
      max-width: 100px;
    }
    i {
      color: red;
    }
  }
}
</style>
